"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SectionRow = SectionRow;
const jsx_runtime_1 = require("react/jsx-runtime");
const utils_1 = require("./utils");
const react_1 = require("react");
function getEndpoint(sectionId) {
    return `/admin/autocomplete/sections/${sectionId}`;
}
function SectionRow({ section, hasSubsections, depth = 0 }) {
    const [showChildren, setShowChildren] = (0, react_1.useState)(false);
    const [shouldFetchChildren, setShouldFetchChildren] = (0, react_1.useState)(false);
    const { data } = (0, utils_1.useQuery)(shouldFetchChildren ? getEndpoint(section.id) : undefined);
    const { onAddSection, onAddWithSubsections, onSelect, hide, shouldHideAfterSelect } = (0, utils_1.useWidgetProps)();
    (0, react_1.useEffect)(() => {
        if (!shouldFetchChildren) {
            setShouldFetchChildren(showChildren);
        }
    }, [showChildren]);
    function handleKeyboardNav(ev) {
        switch (ev.key) {
            case 'ArrowLeft':
                setShowChildren(false);
                break;
            case 'ArrowRight':
                setShowChildren(true);
                break;
            case 'Enter':
                if (ev.ctrlKey) {
                    if (onAddWithSubsections) {
                        onAddWithSubsections(section.id);
                    }
                    break;
                }
                if (onAddSection) {
                    onAddSection(section.id);
                }
                if (onSelect) {
                    onSelect(section.id);
                }
                break;
        }
    }
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)("div", { tabIndex: -1, className: `section-row${depth > 0 ? ' subsection' : ''}`, style: { paddingLeft: `${depth * 28}px` }, onKeyUp: handleKeyboardNav, children: (0, jsx_runtime_1.jsxs)("div", { className: "SectionRow__content", onClick: ev => {
                        if (onSelect) {
                            ev.stopPropagation();
                            if (shouldHideAfterSelect) {
                                hide();
                            }
                            onSelect(section.id);
                        }
                    }, children: [(0, jsx_runtime_1.jsxs)("div", { className: "SectionRow__left", children: [!!hasSubsections && ((0, jsx_runtime_1.jsx)("div", { className: "SectionRow__unwrap-button", children: (0, jsx_runtime_1.jsx)("span", { onClick: ev => {
                                            ev.stopPropagation();
                                            setShowChildren(prev => !prev);
                                        }, className: `bi bi-dash-circle opener ${showChildren ? 'minus' : 'plus'}` }) })), (0, jsx_runtime_1.jsxs)("div", { className: "SectionRow__name", children: [(0, jsx_runtime_1.jsx)("strong", { children: section.name }), !!section.full_path && ((0, jsx_runtime_1.jsx)("span", { className: "SectionRow__full-path", children: section.full_path }))] })] }), (0, jsx_runtime_1.jsxs)("div", { className: "SectionRow__buttons", children: [!!onAddSection && ((0, jsx_runtime_1.jsxs)("button", { type: "button", className: "btn btn-sm btn-primary", onClick: ev => {
                                        ev.stopPropagation();
                                        onAddSection(section.id);
                                    }, children: [(0, jsx_runtime_1.jsx)("span", { className: "bi bi-plus-lg m-r-1" }), " P\u0159idat"] }, "btn-add")), !!onAddWithSubsections && ((0, jsx_runtime_1.jsxs)("button", { type: "button", className: "btn btn-sm btn-secondary", disabled: !hasSubsections, onClick: ev => {
                                        ev.stopPropagation();
                                        onAddWithSubsections(section.id);
                                    }, children: [(0, jsx_runtime_1.jsx)("span", { className: "bi bi-plus-lg m-r-1" }), " V\u010Detn\u011B podsekc\u00ED"] }, "btn-add-all"))] })] }) }), showChildren && (data === null || data === void 0 ? void 0 : data.map((child, i) => ((0, jsx_runtime_1.jsx)(SectionRow, { section: child, depth: depth + 1, hasSubsections: child.has_subsections === 1 }, `c${section.id}-${child.id}-${i}`))))] }));
}
